import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';
import {
  HomeOutlined,
  ShopOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
  NotificationOutlined,
  LogoutOutlined,
  TeamOutlined,
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons';
import { isResumenCuentaEnabledForCoop } from '../../utils/resumenCuentaAccess.js';

const { Content, Sider } = Layout;

const MainLayout = ({ children }) => {
  const { user, logout } = useContext(LoginContext);
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (!user) {
      navigate('/login'); // Redirige al login si no hay usuario
    }
  }, [user, navigate]);

  // Menú para administradores
  const adminMenuItems = [
    { key: '1', icon: <HomeOutlined />, label: <Link to="/">Inicio</Link> },
    { key: '2', icon: <TeamOutlined />, label: <Link to="/usuarios">Usuarios</Link> },
    {
      key: '10',
      icon: <LogoutOutlined style={{ color: 'red' }} />,
      label: (
        <span style={{ color: 'red' }} onClick={() => logout()}>
          Cerrar sesión
        </span>
      ),
    }
  ];

  // Menú para clientes
  const enableResumenCuenta = isResumenCuentaEnabledForCoop(user?.user?.idCooperativa);

  const clientMenuItems = [
    { key: '1', icon: <HomeOutlined />, label: <Link to="/home-cliente">Inicio</Link> },
    { key: '3', icon: <AppstoreOutlined />, label: <Link to="/cereales">Cereales</Link> },
    { key: '4', icon: <ShoppingCartOutlined />, label: <Link to="/supermercado">Supermercado</Link> },
    { key: '5', icon: <ShopOutlined />, label: <Link to="/hacienda">Hacienda</Link> },
    { key: '6', icon: <BarChartOutlined />, label: <Link to="/auditoria">Estadísticas</Link> },
    {
      key: '7',
      icon: <NotificationOutlined />,
      label: 'Difundir',
      children: [
        //{ key: '7-3', label: <Link to="/difundir">Mensaje</Link> },
        { key: '7-1', label: <Link to="/difundir-romaneos">Romaneos</Link> },
        { key: '7-2', label: <Link to="/difundir-cereales">Cereales</Link> },
        ...(enableResumenCuenta
          ? [{ key: '7-3', label: <Link to="/difundir-resumen-cuenta">Resumen de cuenta</Link> }]
          : [])
      ],
    },
    {
      key: '10',
      icon: <LogoutOutlined style={{ color: 'red' }} />,
      label: (
        <span style={{ color: 'red' }} onClick={() => logout()}>
          Cerrar sesión
        </span>
      ),
    }
  ];

  // Seleccionar el menú según el tipo de usuario
  const menuItems = user?.user?.tipoUsuario === 'administrador' ? adminMenuItems : clientMenuItems;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null} // Oculta el trigger por defecto
        style={{
          background: '#000000', // Fondo negro
          color: '#666666', // Color del texto
          position: 'relative',
        }}
      >
        <div className="demo-logo-vertical" />
        <Menu
          theme="dark"
          defaultSelectedKeys={['1']}
          mode="inline"
          items={menuItems}
          style={{
            background: '#000000', // Fondo negro
            color: '#666666', // Color del texto
          }}
        />
        {/* Trigger personalizado */}
        <div
          onClick={() => setCollapsed(!collapsed)}
          style={{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            background: '#000000',
            textAlign: 'center',
            padding: '10px 0',
            cursor: 'pointer',
            color: '#666666', // Cambia el color de la flecha aquí
            fontSize: '18px',
          }}
        >
          {collapsed ? <RightOutlined /> : <LeftOutlined />}
        </div>
      </Sider>
      <Layout>
        <Content
          style={{
            margin: '0px',
          }}
        >
          <div
            style={{
              padding: 12
            }}
          >
            {children}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
